import type { ListingDesignItem } from '../../domain/models/ProductListing';
import { parsePrice } from '@/shared/utils/priceFormatter';

export const PLP_PRODUCT_CLICKED_EVENT_ID = 'plp_product_clicked';

export type PlpProductClickButton = 'wishlist' | 'play_button';

/**
 * Image / title / view-details navigation.
 */
export function buildPlpProductCardClickedPayload(
  product: ListingDesignItem,
): Record<string, string | number> {
  return {
    _eventId: PLP_PRODUCT_CLICKED_EVENT_ID,
    product_id: String(product.designId),
    product_name: product.designName || '',
    product_category: product.categoryType || '',
    product_price: parsePrice(product.price),
    selling_price: parsePrice(product.discountedPrice ?? product.price),
    offer_name: product.discountName || '',
  };
}

/**
 * Wishlist or video play.
 */
export function buildPlpProductButtonClickedPayload(
  product: ListingDesignItem,
  buttonClicked: PlpProductClickButton,
  productPosition: number,
): Record<string, string | number> {
  return {
    _eventId: PLP_PRODUCT_CLICKED_EVENT_ID,
    button_clicked: buttonClicked,
    product_id: product.designId,
    product_category: product.categoryType || '',
    product_name: product.designName || '',
    product_position: productPosition,
    price: parsePrice(product.price),
    discount: product.discountName || '',
    save_amount: parsePrice(product.discountValue),
  };
}
